import type { FC } from 'react';
import { Suspense } from 'react';

import { ModuleHeader } from '@xing-com/crate-entity-pages-common';
import { useEditContext } from '@xing-com/crate-entity-pages-entity-pages-shared-context-edit-context';
import { usePageContext } from '@xing-com/crate-entity-pages-entity-pages-shared-context-entity-page-context';
import { useModuleContext } from '@xing-com/crate-entity-pages-entity-pages-shared-context-module-context';
import {
  NewsList,
  NewsContextProvider,
  getSubPageKey,
  newsPath,
} from '@xing-com/crate-entity-pages-news';

const NewsModuleInner: FC<{ hasSubpage: boolean }> = ({ hasSubpage }) => {
  const { isEditing } = useEditContext();
  const { pageContext } = usePageContext();

  const subPageKey = getSubPageKey(!!isEditing);

  return (
    <>
      <ModuleHeader
        headlineCopyKey="EP_NEWS_HEADLINE"
        showMore={
          hasSubpage
            ? {
                to: newsPath(pageContext.basePath ?? '', pageContext.pageSlug),
                copyKey: `${subPageKey}`,
              }
            : null
        }
      />
      <NewsList />
    </>
  );
};

const Fallback: FC = () => {
  return (
    <ModuleHeader
      headlineCopyKey="EP_NEWS_HEADLINE"
      showMore={{ isLoading: true }}
    />
  );
};

export const NewsModule: FC = () => {
  const { moduleContext } = useModuleContext();
  const hasSubpage = moduleContext?.moduleProperties.hasSubpage;

  return (
    <NewsContextProvider hasSubpage={hasSubpage}>
      <Suspense fallback={<Fallback />}>
        <NewsModuleInner hasSubpage={hasSubpage} />
      </Suspense>
    </NewsContextProvider>
  );
};
